<template>
  <v-dialog v-model="showUnitModal" :scrollable="true" max-width="900px ">
    <v-card>
      <v-card-title>
        <span class="headline">
          <v-icon class="mr-2">fa fa-book</v-icon>
          {{ title }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-data-table
              :headers="headers"
              :items="units"
              class="elevation-1 unit-modal__table"
            >
              <template #item.name="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      target="_blank"
                      color="primary"
                      text
                      v-bind="attrs"
                      v-on="on"
                      @click="gotoUnitPage(item.id)"
                    >
                      {{ item.name }}
                    </v-btn>
                  </template>
                  <span>View</span>
                </v-tooltip>
              </template>
              <template v-slot:item.due_date="{ item }">
                {{ formatDate(item.due_date) }}
              </template>
              <template v-slot:item.date_completed="{ item }">
                {{ formatDate(item.date_completed) }}
              </template>
            </v-data-table>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue-grey" dark @click="showUnitModal = false">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dayjs from 'dayjs';
export default {
  name: 'UnitModal',
  props: ['value', 'units', 'title', 'isPlaylist'],
  data() {
    return {
      headers: [
        {
          text: 'Name',
          tooltip: 'Name of Units',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        {
          text: 'From Module',
          align: 'center',
          sortable: true,
          value: 'module_name',
        },
        {
          text: 'Finished Video',
          align: 'center',
          sortable: true,
          value: 'finished_video',
        },
        {
          text: 'Due Date',
          align: 'center',
          sortable: true,
          value: 'due_date',
        },
        {
          text: 'Date Completed',
          align: 'center',
          sortable: true,
          value: 'date_completed',
        },
      ],
    };
  },
  computed: {
    showUnitModal: {
      get() {
        return this.value;
      },
      set(value) {
        this.$parent.isPlaylist = false;
        this.$emit('input', value);
      },
    },
  },
  mounted() {
    if (this.isPlaylist) {
      this.headers[1].text = 'From Playlist';
      this.headers[1].value = 'playlist_name';
    }
  },
  methods: {
    formatDate(date) {
      if (!date) return 'N/A';
      return dayjs(date).format('MMM D, YYYY, h:mm a');
    },
    gotoUnitPage(id) {
      let routeData = this.$router.resolve({
        name: 'UnitPage',
        params: { id: id },
      });
      window.open(routeData.href, '_blank');
    },
  },
};
</script>

<style lang="stylus">
.unit-modal__table
  width 100%
</style>
